import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import { BillingCard } from '/@/modules/billing/models/BillingCard';

export class BillingPaymentSource extends BaseBillingEntity {
  /**
   * @var {BillingCard}
   */
  card;

  /**
   * @var {number}
   */
  createdAt;

  /**
   * @var {string}
   */
  customerId;

  /**
   * @var {boolean}
   */
  deleted;

  /**
   * @var {string}
   */
  gateway;

  /**
   * @var {string}
   */
  gatewayAccountId;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {string}
   */
  referenceId;

  /**
   * @var {string}
   */
  status;

  /**
   * @var {string}
   */
  type;

  constructor(model = {}) {
    super(model);

    this.card = BillingCard.mapModel(model.card);
    this.createdAt = model.createdAt;
    this.customerId = model.customerId;
    this.deleted = model.deleted;
    this.gateway = model.gateway;
    this.gatewayAccountId = model.gatewayAccountId;
    this.id = model.id;
    this.object = model.object;
    this.referenceId = model.referenceId;
    this.status = model.status;
    this.type = model.type;
  }
}
